import { TipoDivida } from "./types";

export type EditTipoDividaProperty =
  | "SET_TIPO_DIVIDA"
  | "UNSET_TIPO_DIVIDA"
  | "SET_NOME"
  | "SET_CODIGO_CONTRATO"
  | "SET_TIPO_DOCUMENTO"
  | "SET_TIPO_MOVIMENTO";

export const INITIAL_STATE = {
  nomeDivida: "",
  codigoContrato: "",
  tipoDocumentos: "",
  tipoMovimentos: "",
};

export function reducer(
  state: TipoDivida,
  { type, payload }: { type: EditTipoDividaProperty; payload?: any }
): any {
  switch (type) {
    case "SET_TIPO_DIVIDA":
      return {
        ...payload,
      };
    case "UNSET_TIPO_DIVIDA":
      return undefined;
    case "SET_NOME":
      return {
        ...state,
        nomeDivida: payload,
      };
    case "SET_CODIGO_CONTRATO":
      return {
        ...state,
        codigoContrato: payload,
      };
    case "SET_TIPO_DOCUMENTO":
      return {
        ...state,
        tipoDocumentos: payload,
      };
    case "SET_TIPO_MOVIMENTO":
      return {
        ...state,
        tipoMovimentos: payload,
      };
    default:
      return state;
  }
}
